// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js!./bootstrap-vue.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("7f57c5fd", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/dist/bootstrap-vue.css
// module id = 492
// module chunks = 0